enum AdminRoleEnum {
  ALL = 0,
  SUPER_ADMIN = 1,
  ADMIN = 2,
  STAFF = 3
}

export default AdminRoleEnum;
